// extracted by mini-css-extract-plugin
export default {"wrap":"ErrorView_wrap__m4UzV","name":"ErrorView_name__Ih-DC","wrapMast":"ErrorView_wrapMast__yaP5P","toTopBtn":"ErrorView_toTopBtn__qjAd9"};